<ion-toolbar color="transparent" >
    <ion-icon *ngIf="showLastButton" (click)="handleClick('last')" slot="start" src="assets/img/arrowLast.svg"></ion-icon>
    <ion-icon *ngIf="!hideNextButton" (click)="handleClick('next')" slot="end" src="assets/img/arrowNext.svg"></ion-icon>
</ion-toolbar>
